export default "__VITE_ASSET__CLyJlaJV__"